@if (optionsFetched) {
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="input-header-group">
                    <span class="input-header">Pick a Source</span>
                    <wj-combo-box
                        id="isActive"
                        style="width: 150px"
                        [(ngModel)]="selectedSource"
                        (ngModelChange)="refresh()"
                        name="isActive"
                        [itemsSource]="sourcesList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <grid-column-group [grid]="reconGrid"></grid-column-group>
            <wj-flex-grid
                id="gridRecon"
                #gridRecon
                appAutoSize
                [padding]="73"
                (initialized)="reconGrid.initialize(gridRecon)"
                [itemsSource]="reconGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Lifetime Meter Delta'" [binding]="'lifetimeMeterDelta'" [width]="'*'" [format]="'N2'">
                </wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Gallons Pumped Total'"
                    [binding]="'gallonsPumpedTotal'"
                    [width]="'*'"
                    [format]="'N2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Missing Fuel'" [binding]="'delta'" [width]="'*'" [format]="'N2'"></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="gridRecon"></grid-selection-calculation>
        </div>
    </div>
}
